// remove this once the new API's are built

const readCsrfTokenFromCookie = (): string | undefined => {
  if (typeof document === "undefined") return undefined;
  const match = document.cookie.match(/(?:^|; )X-CSRF-Token=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : undefined;
};

export const signinUser = (
  emailOrLogin: string,
  password: string | undefined,
  rememberMe: "0" | "1",
  otp?: string,
  targetWindow?: any
): void => {
  if (process.env.NODE_ENV === "development") {
    return;
  }

  const doc = targetWindow ? targetWindow.document : document;

  const form = doc.createElement("form");
  form.setAttribute("method", "post");
  form.setAttribute("action", "/users/session");
  form.style.display = "none";

  const emailEl = doc.createElement("input");
  emailEl.setAttribute("name", "user[email_or_login]");
  emailEl.setAttribute("value", emailOrLogin);
  form.appendChild(emailEl);

  if (password) {
    const passwordEl = doc.createElement("input");
    passwordEl.setAttribute("name", "user[password]");
    passwordEl.setAttribute("value", password);
    form.appendChild(passwordEl);
  }

  const rememberMeEl = doc.createElement("input");
  rememberMeEl.setAttribute("name", "user[remember_me]");
  rememberMeEl.setAttribute("value", rememberMe);
  form.appendChild(rememberMeEl);

  if (otp) {
    const otpEl = doc.createElement("input");
    otpEl.setAttribute("name", "user[otp]");
    otpEl.setAttribute("value", otp);
    form.appendChild(otpEl);
  }

  const csrf = readCsrfTokenFromCookie();
  if (csrf) {
    const csrfEl = doc.createElement("input");
    csrfEl.setAttribute("type", "hidden");
    csrfEl.setAttribute("name", "authenticity_token");
    csrfEl.setAttribute("value", csrf);
    form.appendChild(csrfEl);
  }

  doc.body.appendChild(form);
  form.submit();
};
